<template>
  <div class="home">
    <div class="shop-container">
      <div class="nav-wrap">
        <all-classify></all-classify>
        <div class="banner-list">
          <el-carousel arrow="never" height="440px">
            <el-carousel-item v-for="(item,index) in bannerArr" :key="index">
              <img :src="item.img" :alt="item.name">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <new-shop-list :newsList="newsShopList"></new-shop-list>
      <!-- <div class="banner"></div> -->
      <template>
        <div v-for="(listItem,index) in loftData" :key="index">
          <product-loft
            :headTitle="listItem.name"
            :list="listItem.goods"
            :advLeft="listItem.adv.left"
            :keyword="listItem.keyword"
          ></product-loft>
          <one-shop :shopImg="listItem.adv.bottom"></one-shop>
        </div>
      </template>
    </div>
    <ScrollToTop></ScrollToTop>
    <el-dialog title="领取优惠券" :visible.sync="centerDialogVisible" width="400px" center>
      <div class="coupon-list">
        <div class="coupon-wrap" v-for="(item,index) in couponList" :key="index">
          <div class="content">
            <div class="price">
              <span class="num">{{item.name}}</span>
            </div>
            <div class="desc">{{item.expression1}}&nbsp;&nbsp;{{item.expression2}}</div>
            <div class="time">{{item.stime}}&nbsp;--&nbsp;{{item.etime}}</div>
          </div>
          <div class="status">
            <a href="javascript:;" @click="userGetCoupon(item.id)">立即领取</a>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src

import AllClassify from "@/components/common/AllClassify.vue";
import NewShopList from "@/components/home/NewShopList.vue";
import ProductLoft from "@/components/home/ProductLoft.vue";
import OneShop from "@/components/home/OneShop.vue";
import ScrollToTop from "@/components/common/ScrollToTop.vue";

export default {
  data() {
    return {
      allClassifyData: [], //所有商品分类
      bannerArr: [],
      newsShopList: [], //新品上市,
      loftData: [],
      couponList: [], //优惠券列表
      centerDialogVisible: false
    };
  },
  name: "Home",
  components: {
    AllClassify,
    NewShopList,
    ProductLoft,
    // ReCommend,
    OneShop,
    ScrollToTop
  },
  mounted() {
    this.getHomeSlider();
    this.getRecomendList();
    this.getLoftData();
    this.getCouponList();
  },
  methods: {
    getLoftData() {
      this.$api.homeLoftData().then(res => {
        if (res.status) {
          this.loftData = res.data;
        }
      });
    },
    //获取首页banner轮播
    getHomeSlider() {
      // let data={ 
      //   code: "pc_home_slider"
      // }
      let data = {
        code: "tpl1_slider"
      };
      this.$api.slider(data).then(res => {
        if (res.status) {
          this.bannerArr = res.data.list;
        }
      });
    },
    //获取新品上市
    getRecomendList() {
      let data = {
        where: JSON.stringify({
          recommend: 1
        })
      };
      let option = {
        page: 1,
        limit: 10
      };
      let params = Object.assign(data, option);
      this.$api.goodsList(params).then(res => {
        if (res.status) {
          this.newsShopList = res.data.list;
        }
      });
    },
    // 获取商户优惠券信息
    getCouponList() {
      this.$api.couponList().then(res => {
        if (res.status) {
          this.couponList = res.data;
          if(res.data.length>0){
            this.centerDialogVisible=true
          }
        }
      });
    },
    //领取优惠券
    userGetCoupon(id) {
      this.$api.getCoupon({ promotion_id: id }).then(res => {
        if(res.status){
          this.$msg(res.msg)
        }else{
          this.$msg(res.msg,'warning')
        }
        this.centerDialogVisible=false;
      });
    }
  },
  deactivated(){
    this.centerDialogVisible=false;
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.nav-wrap {
  width: 100%;
  position: relative;
  height: 440px;

  .banner-list {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 440px;
    z-index: 10;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.banner {
  width: 100%;
  height: 376px;
}
.coupon-list {
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
}

</style>
